import {ScadaMode, scadaModes} from "@ots-frontend/ots-data";
import {BaseDbCodeSelect, DbCodeSelectProps} from "../base-db-code-select";

type Props = DbCodeSelectProps<ScadaMode>

export const ScadaModeSelect = (props: Props) => {
  const {options = scadaModes, ...rest} = props;
  return <BaseDbCodeSelect options={options} {...rest} />;
};
